import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, retry } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private utils: UtilsService, private http: HttpClient) { }

  getCityDataFromPinCode(pincode: any): Observable<any> {
    let body = {
      pinCode: pincode
    }
    let url = this.utils.apiUrl + 'MasterPinCodes/GetAllPinCodeDetailByUsingPinCode';
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

  getAddressList(): Observable<any> {
    let url = this.utils.apiUrl + 'Address/GetCustomerAddresses';
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  addOrUpdateAddress(addressData: any): Observable<any> {
    let body: any = {
      "fullName": addressData.full_name,
      "landmark": addressData.landmark ? addressData.landmark.trim() : '',
      "houseNo": addressData.house_no__apartment ? addressData.house_no__apartment.trim() : '',
      "streetAddress": addressData.street_address ? addressData.street_address.trim() : '',
      "city": addressData.city ? addressData.city.trim() : '',
      "state": addressData.state,
      "country": addressData.country,
      "pinCode": addressData.pin_code,
      "contactNo": addressData.phone_no,
      "isDefault": addressData.default_address ? addressData.default_address : false,
      "isActive": true
    }
    let url = this.utils.apiUrl;
    if (addressData.addressGuid) {
      body['guidId'] = addressData.addressGuid;
      url += 'Address/UpdateAddress';
    }
    else
      url += 'Address/AddAddress';
    return this.http.post(url, body).pipe(catchError(this.utils.processError.bind(this)));
  }

  updateDefaultAddress(addressId: any): Observable<any> {
    let url = this.utils.apiUrl + `Address/MakeAddressDefault/${addressId}`;
    return this.http.get(url).pipe(catchError(this.utils.processError.bind(this)));
  }

  deleteAddress(addressId: any) {
    let url = this.utils.apiUrl + `Address/DeleteAddress/${addressId}`;
    return this.http.delete(url).pipe(catchError(this.utils.processError.bind(this)));
  }
}
